import styled, { css } from 'styled-components';

import { FormBuilderButtonWrapperStyled } from './FormBuilderButton.types';

export const FormBuilderTypographyButtonWrapper = styled.div<FormBuilderButtonWrapperStyled>`
  margin-bottom: ${({ marginBottom = 20 }) => marginBottom}px;
  margin-top: ${({ marginTop = 0 }) => marginTop}px;
  cursor: pointer;

  ${({ fullWidth }) =>
    fullWidth
      ? css`
          width: 100%;
        `
      : ''}

  :not(.FormBuilderButton_CTA_Wrapper):hover {
    text-decoration: underline;
  }
`;
